import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Edit } from "lucide-react";
import Dialog from "../../../../../../../../../components/shared/Dialog";
import Button from "../../../../../../../../../components/shared/Button";
import { Field } from "../../../../../../../../../components/shared/Form";
import JobSelect from "../../components/JobSelect";
import LocationSelect from "../../components/LocationSelect";
import QualificationSelect from "../../components/QualificationSelect";
import { useQualificationPreferences } from "../../../../../../hooks/useQualificationPreferences";
import { useRowGroupBy } from "../../../../../../hooks/form/useRowGroupBy";

type EditModalProps = {
    index: number;
    disabled?: boolean;
    contentClassName?: string;
};

function EditModal({ index, disabled, contentClassName }: EditModalProps) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const qualifications = useQualificationPreferences();
    const rowGroupBy = useRowGroupBy();

    const resetFields = useCallback(() => {
        // TODO reset with initial values || remove this
    }, []);

    const handleSave = useCallback(() => setOpen(false), []);

    const handleCancel = useCallback(() => {
        resetFields();
        setOpen(false);
    }, [resetFields]);

    const close = useCallback((value: boolean) => {
        if (!value) resetFields();
        setOpen(value);
    }, [resetFields]);

    return (
        <>
            <Edit className="tw-cursor-pointer" size={16} onClick={() => setOpen(true)} />

            <Dialog open={open} close={close} title={t("edit-shift")} size="xl" contentClassName={contentClassName}>
                <Field
                    name={`sections.${index}.job`}
                    label={t("job")}
                    layout="row"
                    shouldUnregister={false}
                >
                    <JobSelect disabled={disabled || rowGroupBy?.field === "job"} />
                </Field>

                <Field
                    name={`sections.${index}.location`}
                    label={t("location")}
                    layout="row"
                    shouldUnregister={false}
                >
                    <LocationSelect disabled={disabled || rowGroupBy?.field === "location"} />
                </Field>

                {qualifications.skills && (
                    <Field
                        name={`sections.${index}.skills`}
                        label={t("skills")}
                        layout="row"
                    >
                        <QualificationSelect field="skills" disabled={disabled} />
                    </Field>
                )}

                {qualifications.licenses && (
                    <Field
                        name={`sections.${index}.licenses`}
                        label={t("licenses")}
                        layout="row"
                    >
                        <QualificationSelect field="licenses" disabled={disabled} />
                    </Field>
                )}

                {qualifications.certifications && (
                    <Field
                        name={`sections.${index}.certifications`}
                        label={t("certifications")}
                        layout="row"
                    >
                        <QualificationSelect field="certifications" disabled={disabled} />
                    </Field>
                )}

                <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
                    <Button variant="ghost" onClick={handleCancel}>
                        {t("cancel")}
                    </Button>
                    {!disabled && (
                        <Button onClick={handleSave}>
                            {t("save")}
                        </Button>
                    )}
                </div>
            </Dialog>
        </>
    );
}

export default EditModal;
